import { GridColDef } from '@material-ui/data-grid';

export const ColumnCompany: GridColDef = {
  field: 'company',
  headerName: 'Empresa',
  width: 500,
};

export const ColumnIdUsuario: GridColDef = {
  field: 'id_usuario',
  headerName: '# Usuário',
  hide: true,
  width: 300,
};

export const ColumnUsuario: GridColDef = {
  field: 'usuario',
  headerName: 'Usuário',
  width: 550,
};

export const ColumnDescricaoModulo: GridColDef = {
  field: 'desc_modulo',
  headerName: 'Módulo',
  width: 250,
};

export const ColumnDescricaoMenu: GridColDef = {
  field: 'desc_menu',
  headerName: 'Menu',
  width: 180,
};

export const ColumnDescricaoRelatorio: GridColDef = {
  field: 'desc_relatorio',
  headerName: 'Relatóio',
  width: 200,
};

export const ColumnObservacao: GridColDef = {
  field: 'obs',
  headerName: 'Observação',
  width: 500,
};

export const ColumnInformacao1: GridColDef = {
  field: 'inf1',
  headerName: 'Informação 1',
  width: 500,
};

export const ColumnInformacao2: GridColDef = {
  field: 'inf2',
  headerName: 'Informação 2',
  width: 500,
};

export const ColumnInformacao3: GridColDef = {
  field: 'inf3',
  headerName: 'Informação 3',
  width: 500,
};

export const ColumnInformacao4: GridColDef = {
  field: 'inf4',
  headerName: 'Informação 4',
  width: 500,
};

export const ColumnInformacao5: GridColDef = {
  field: 'inf5',
  headerName: 'Informação 5',
  width: 500,
};

export const ColumnID: GridColDef = {
  field: 'access_key',
  headerName: '#',
  width: 400,
  hide: true,
  editable: false,
  filterable: false,
  hideSortIcons: true,
  sortable: false,
  disableColumnMenu: true,
};
